import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import api from "utils/API";
import apiform from "utils/APIForm";
import { getListAllSupplies } from 'actions/getListAction';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";


export default function ModalAceptReceptionPending(props) {
  const { open, closeModal, productos_restantes, id_order, moduleType } = props;
  const [order, setOrder] = useState([]);
  const descriptionElementRef = React.useRef(null);
  const [scroll, setScroll] = useState("paper");

  const dispatch = useDispatch();
  const dictAllSupplies = useSelector(state => state.currentList.dictAllSupplies);
  const chargeAllSupplies = useSelector(state => state.currentGlobalVar.chargeAllSupplies);
  const insumos = Object.values(dictAllSupplies);

  const { getEnviosPedidos } = props;

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    api.get(`api/solicitudpedidos/${id_order}`).then(response => {
      setOrder(response.data);
    });
    if (Object.keys(dictAllSupplies).length === 0) {
      getListAllSupplies(dispatch, chargeAllSupplies);
    }
  }, []);

  function updateBenefit() {
    const formData = new FormData();

    formData.append("estado", "Adjuntar guía");
    formData.append("estado_egreso", "Adjuntar guía");

    const requestSend = apiform.patch(`api/enviospedidos/${getEnviosPedidos.id}`, formData)
    Promise.all([requestSend])
      .then(response => {
        window.location.href = `/admin/outcome/receptions/${moduleType}`;
      })
      .catch(error => {
        alert(`Error ${error.response?.data || error.message}`);
      });

  }

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="sm"
      fullWidth={true}
      disableBackdropClick
    >
      <DialogTitle id="scroll-dialog-title">Resumen del pedido</DialogTitle>
      <DialogContent dividers={scroll === "paper"}>
        <div className="form" style={{ marginBottom: "3rem" }}>
          El pedido quedo con los siguiente pendientes: <br />
          <div className="mt-2 mb-3">
            <ul className="list-group">
              {null}
              {productos_restantes.map(producto => (
                <li key={producto.id} className="list-group-item">
                  {producto.id_producto_pedido.cantidad_por_enviar}
                  {producto.id_producto_pedido.id_insumo_medicamento.tipo_cantidad}
                   de
                  {producto.id_producto_pedido.id_insumo_medicamento.descripcion_producto}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div>
          <span className="font-weight-bold">
            ¿Estás seguro que deseas recepcionar el pedido?
          </span>
          <br />
          <p className="text-center">
            Se enviará un correo automáticamente a los contactos del paciente.
          </p>
          <p className="text-center">
            Los productos pedidos se descontarán del stock automáticamente.
          </p>
          <p className="text-center">
            Se descargará la guía de despacho automáticamente para que sea adjuntada posteriormente.
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="primary">
          No
        </Button>
        <Button onClick={updateBenefit} color="primary">
          Si
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalAceptReceptionPending.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.bool,
  productos_restantes: PropTypes.array,
  id_order: PropTypes.number
};
